import React from 'react';

import { Quantity, QUANTITY_ID } from 'src/components/atoms/Quantity/Quantity';

export interface QuantitySelectorDispatchProps {
  onChangeQuantity: (payload: { quantity: number; valid: boolean }) => void;
}

export interface QuantitySelectorStateProps {
  inStock: boolean;
  quantity: number;
}

export interface QuantitySelectorOwnProps {
  /**
   * Distinguishes this instance's element ids. Any product with options renders one of these on
   * the page and another in the options drawer at the same time, and duplicate ids would break
   * the label association for both.
   */
  idSuffix?: string;
}

export type QuantitySelectorProps = QuantitySelectorDispatchProps &
  QuantitySelectorOwnProps &
  QuantitySelectorStateProps;

export const QuantitySelector = ({
  idSuffix,
  inStock,
  onChangeQuantity,
  quantity,
}: QuantitySelectorProps) => {
  if (!inStock) {
    return null;
  }

  return (
    <Quantity
      defaultValue={quantity}
      id={idSuffix ? `${QUANTITY_ID}-${idSuffix}` : QUANTITY_ID}
      onChange={(quantity, valid) => {
        onChangeQuantity({ quantity, valid });
      }}
    />
  );
};
